<template>
  <div class="auth-form-container">
    <internal-loading v-if="internalLoading"></internal-loading>
    <div class="auth-form" id="form-builder"></div>
    <el-button @click="onSubmit" class="auth-button">AVANÇAR</el-button>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { renderForm } from '@mobilesaude/form-builder-sdk'
import internalLoading from '../../shared/loading/InternalLoading'

export default {
  name: 'FormValidaContexto',
  components: {
    internalLoading
  },
  data () {
    return {
      internalLoading: true,
      form: null,
      title: 'Acesse sua conta',
      subTitle: 'Entre com suas credenciais de acesso Mobile Saúde',
      buttonBack: false
    }
  },
  mounted () {
    if (this.idsforms.formContexto) {
      let params = {
        identifier: 'form-builder',
        clientKey: process.env.VUE_APP_CLIENTE_KEY,
        idForm: this.idsforms.formContexto,
        colors: {
          primary: '#0075EA',
          errors: '#ff4949'
        },
        json: {
          contexto: this.contexto.slug
        }
      }
      this.form = renderForm(params)
      this.form.on('LOADING', res => {
        this.internalLoading = res
      })
    }
  },
  watch: {
    idsforms: function (filled, empty) {
      if (empty.formContexto === '') {
        this.idsforms.formContexto = filled.formContexto
        let params = {
          identifier: 'form-builder',
          clientKey: process.env.VUE_APP_CLIENTE_KEY,
          idForm: this.idsforms.formContexto,
          colors: {
            primary: '#0075EA',
            errors: '#ff4949'
          },
          json: {
            contexto: this.contexto.slug
          }
        }
        this.form = renderForm(params)
        this.form.on('LOADING', res => {
          this.internalLoading = res
        })
      }
    }
  },
  methods: {
    ...mapActions('login', ['validaContexto']),
    onSubmit () {
      this.form.validateAll().then(form => {
        this.validaContexto(form.data)
      })
    }
  },
  computed: {
    ...mapState('login', ['contexto', 'loading', 'idsforms'])
  },
  created () {
    this.$store.dispatch('login/getIds')
    this.$store.dispatch('login/startLoading')
    this.$root.$emit('set-data-auth', {
      title: this.title,
      subTitle: this.subTitle,
      buttonBack: this.buttonBack
    })
    this.$store.dispatch('login/stopLoading')
  }
}
</script>
<style lang="sass" scoped>
  @import url('https://fonts.googleapis.com/css?family=Nunito&display=swap')
  @import '../../../views/auth/auth.scss'
</style>
